<template>
    <div>
        <div class="w">
            <div class="oheader">
                <a href="/" title="夜樱情趣" class="left">
                    <img src="../../assets/image/logo.png">
                </a>
                <!-- <a href="javascript:;" onclick="jieshou()" class="xhb right"><em class="f pr5 f14"></em>联系客服</a> -->
                <a href="/" class="xhb right mr10">继续购物</a>
                <div class="clear"></div>
            </div>
        </div>
        <div class="w" id="content" v-if="rechangePayOrderInfo.status==0">
            <div id="yanOk" class="mb30">
                <div class="okbox pay_12">
                    <p><img src="https://s.cccgx.com/themes/v4/css/b/down_wait.png" class="ico1"></p>
                    <p class="h3" id="repd">等待支付</p>
                    <p class="h1" style="margin:20px 0;"><b class="f12">¥</b>{{$fnc.toFixedZ(allPrice,2)}}</p>
                    <p class="h2">订单提交成功,请用微信扫码支付.</p>
                    <div id="paydiv" class="pd15 ov" style="font-size:20px;background:#e9e9e9;color: #969696;display: inline-block;border-radius:30px;padding:20px">
                        支付剩余时间：
                        <downtime :day="time" :hour="hour" :minute="minute" style="display: inline-block;" :second="second" :show-colon="false" time="days" backgroundColor="none" splitorColor="#969696" color="#969696" @timeup="timeup"></downtime>
                    </div>
                    <div class="wx_saoma">
                        <div id="codeimg"></div>
                        <div class="wx_zbg">
                            <p><img src="https://s.cccgx.com/themes/v4/css/b/wxpayb2.png" width="150" height="40"></p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="w" id="content" v-else>
            <div style="text-align:center;font-size:20px;font-weight:bold;color:#f00180;">订单过期未支付，已关闭</div>
            <div style="text-align:center;font-size:20px;font-weight:bold;margin-top:50px;">
                <span style="padding:10px 20px;background:#f00180;color:#ffffff;margin-right:20px;"><a href="/" style="color:#ffffff;">返回首页</a></span>
                <span style="padding:10px 20px;background:#f00180;color:#ffffff;"><a href="/user_infor" style="color:#ffffff;">返回会员中心</a></span>
            </div>
        </div>
        <p class="bf_footer">
            <a href="/" class="c9" target="_blank">首页</a>
            <em class="vline">|</em>
            <a href="javascript:;" class="c9"  v-for="(items,index) in category" :key="items.id"  @click="catesearch(items.title,index)">
                {{items.title}}
                <em class="vline">|</em>
            </a>
        </p>
        <p class="fuwu">下单代表同意夜樱情趣 <a href="/help/fuwuxieyi" class="U" target="_blank">服务协议</a><a href="/help/falvshengming" class="U" target="_blank">法律声明</a><a href="/help/yinsibaohu" class="U" target="_blank">隐私政策权</a></p>
    </div>
</template>

<script>
import Downtime from '../car/downtime.vue'
import QRCode from 'qrcodejs2'

export default {
    components:{
        "downtime" : Downtime,
    },
    data(){
        return{
            x: 0,
            y: 0,
            node: null,
            isCanMove: false,
            active:0,
            pay_needpass: 0,
            pay_title: "",
            password:"",
            currentTime: 0,
            startTime: 0,
            endTime: 0,
            time: 0,
            hour: 0,
            minute: 0,
            second: 0,
            payList:{},
            pays:0,
            payRechanges:"",
            info: {},
            date:"",
            price:"",
            show:false,
            category:[],
            orderInfo:"",
            orderMoney:"",
            odata:{},
            routerData:"",
            payPrice:"",
            allPrice:"",
            offer:"",
            rechangePayOrderInfo:{},
            timer: null
        }
    },
    created () {
        this.getShopCate();
        this.getPayInfo();
    },
    mounted() {
        this.node = document.querySelector('.modal-container')
        this.getQRcode()
        this.getList()
    },
    methods:{
        //获取所有商品分类
        getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.category = [];
                    var arr = res.result.cate;
                    arr.forEach(item => {
                        if (item.show == 1) {
                            this.category.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 2){
                this.$router.push(`/biyuntao/`);
            }else if(index == 3){
                this.$router.push(`/zhuxing/`);
            }else if(index == 4){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 5){
                this.$router.push(`/tehui/`);
            }
        },
        timeup () {
            this.getPayInfo();
        },
        getPayInfo () {
            var params = {};
            params.id = this.$route.query.id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getOrder.getRechangePayOrderInfo(params).then(res=>{
                if(res.code == 200){
                    this.rechangePayOrderInfo = res.result;
                    this.allPrice = (res.result.money);
                    this.date = 1800;
                    this.time = parseInt(this.date / 3600 / 24);
                    this.hour = parseInt(this.date / 3600) - 24;
                    this.time = Math.floor(this.date / (60 * 60 * 24));
                    this.hour = Math.floor((this.date - this.time * 24 * 60 * 60) / 3600);
                    this.minute = Math.floor((this.date - this.time * 24 * 60 * 60 - this.hour * 3600) / 60);
                    this.second = Math.floor(this.date - this.time * 24 * 60 * 60 - this.hour * 3600 - this.minute * 60);
                    this.$api.getOrder.subWxPayOrder(params).then(ress=>{
                        if(ress.code == 200){
                            // 前端根据 URL 生成微信支付二维码
                            this.$nextTick(() => {
                                setTimeout(()=>{
                                    var qrcode = new QRCode("codeimg", {
                                        width: 220,
                                        height: 220,
                                        text: ress.result,
                                        colorDark: '#000',
                                        colorLight: '#fff'
                                    });
                                },1000)
                            });
                        }
                    })
                }
            })
        },
        //获取该交易订单
        getList(){
            var params = {};
            params.id = this.$route.query.id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getOrder.getRechangeList(params).then(res=>{
                if(res.code == 200){
                    this.odata = res.result;
                }
            })
        },
         // 定时查询交易状态
        getQRcode() {
            this.timer = window.setInterval(() => {
                if(this.odata.status == 0){
                    this.getList();
                }else{
                    this.$router.push('/recharge')
                }
            }, 5000);
        },
        
    },
    destroyed() {
        window.clearInterval(this.timer)
    }
}
</script>


<style scoped>
@import url('../../assets/css/style.css');
@import url('../../assets/css/car.css');
.ip_t {
    border: 1px solid #eee;
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    border-radius: 4px;
    font-size: 14px;
}
.active{
    color: #000;
    background: url(../../assets/image/v.png) right -474px no-repeat;
    border-color: #f00180;
    border-width: 2px;
    padding: 7px 9px 7px 39px;
    -webkit-box-shadow: 0px 0px 5px #f5a0aa;
    box-shadow: 0px 0px 5px #f5a0aa;
}
.modal-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    z-index: 10;
}
.modal-container {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.modal-header {
    height: 56px;
    background: #409EFF;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: move;
}
.modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    border-top: 1px solid #ddd;
}
.modal-footer button {
    width: 100px;
    font-size: 16px;
}
.modal-main {
    padding: 30px 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/recharge/wx.vue